module.exports = __webpack_public_path__ + "static/img/biomass-burner_256.71e2872.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/biomass-burner_256.png
// module id = CAor
// module chunks = 0